import React from 'react';

import { itemsPropType } from './prop-types';

export default class DeleteConfirmation extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleCancelDelete = this.handleCancelDelete.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
  }

  handleCancelDelete() {
    this.props.dispatch({ type: 'cancelDelete' });
  }

  handleConfirmDelete() {
    this.props.dispatch({ type: 'confirmDelete' });
  }

  render() {
    const { items } = this.props;

    return (
      <div className="modal-sheet asset-delete">
        <div className="content">
          <div className="warning-header-icon svg-ico-warning4" />
          <div className="warning-header-title">Delete Assets</div>
          <div className="warn">
            <p className="warn-message">
              Are you sure you want to delete
              {items.length > 1 ? ` these ${items.length} assets?` : ' this asset?'}
            </p>
            <ul className="delete-file-list">
              {items.map(item => <li key={item.id}>{item.asset.content_file_name}</li>)}
            </ul>
          </div>
          <div className="delete-actions">
            <a className="button delete modal-button" onClick={this.handleConfirmDelete}>
              <span className="label">Yes, Delete</span>
            </a>
            <a className="button cancel modal-button" onClick={this.handleCancelDelete}>
              <span className="label">Cancel</span>
            </a>
          </div>
          <div className="caution">Caution: This cannot be undone.</div>
        </div>
      </div>
    );
  }
}

DeleteConfirmation.propTypes = {
  items: itemsPropType.isRequired,
  dispatch: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/asset-library/delete-confirmation.jsx